<template>
    <div class="basic-info">
        <div class="info-header" @click="changeState('isBasicInfoShow')">
            <div class="info-header-left">
                <span class="info-header-block"></span>
                <span class="info-header-text">基础信息</span>
            </div>
            <i :class="['el-icon', 'mgr-10', isBasicInfoShow ? 'el-icon-arrow-down' :'el-icon-arrow-right']"></i>
        </div>
        <div v-show="isBasicInfoShow">
            <el-form label-position="left" label-width="130px" class="basic-wrapper">
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="司机：" >
                            <i class="el-icon-user el-icon mgr-10"></i>
                            <span @dblclick="copyText($event)">{{ basicInfo.driver || '--'}}</span>
                            <i class="el-icon-phone el-icon mg-10"></i>
                            <span @dblclick="copyText($event)">{{ basicInfo.driverContactWay || '--'}}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="车牌：">
                            <span @dblclick="copyText($event)">{{ basicInfo.vehicleCard || '--'}}</span>
                            <i class="el-icon-map-location el-icon mg-10" title="点击跳转至发车单在途监控页面" @click="linkToMapMonitor"></i>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="承运商：">
                            <el-tooltip
                                class="item"
                                effect="dark"
                                :content="basicInfo.carrierName || '--'"
                                placement="top-start"
                            >
                                <span @dblclick="copyText($event)">{{ basicInfo.carrierName || '--'}}</span>
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="采购渠道：">
                            <span @dblclick="copyText($event)">{{ basicInfo.procurementChannelName || '--' }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="计费车型：">
                            <template #label>
                                <span>计费车型</span>
                                <el-tooltip :content="equipmentRequirement" placement="top-start">
                                    <i class="el-icon-question" style="font-size: 15px; margin-left:2px;"></i>
                                </el-tooltip>
                                <span>：</span>
                            </template>
                            <el-tooltip
                                class="item"
                                effect="dark"
                                :content="`${basicInfo.equipmentName || '--'}(内径长宽高:${formateValue(basicInfo.interiorLength)}/
                                ${formateValue(basicInfo.interiorWidth)}/${formateValue(basicInfo.interiorHeight)})`"
                                placement="top-start"
                            >
                                <span>
                                    <span @dblclick="copyText($event)">{{ basicInfo.equipmentName || '--' }}</span>
                                    <span @dblclick="copyText($event)">
                                        (内径长宽高：{{ formateValue(basicInfo.interiorLength) }}/
                                        {{ formateValue(basicInfo.interiorWidth) }}/
                                        {{ formateValue(basicInfo.interiorHeight) }})
                                    </span>
                                </span>
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="服务平台：">
                            <el-tooltip
                                class="item"
                                effect="dark"
                                :content="`${basicInfo.siteName || '--'}(${basicInfo.companyName || '--'})`"
                                placement="top-start"
                            >
                                <span @dblclick="copyText($event)">{{ basicInfo.siteName || '--' }}({{ basicInfo.companyName || '--' }})</span>
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="专业公司：">
                            <span @dblclick="copyText($event)">{{ basicInfo.professionalCompany || '--' }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="合同外场景：">
                            <span @dblclick="copyText($event)">{{ basicInfo.contractOutName || '--' }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否顺路带回：">
                            <span @dblclick="copyText($event)">{{ basicInfo.convenientlyName || '--' }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="发运类型：">
                            <span @dblclick="copyText($event)">{{ basicInfo.shippingTypeName || '--' }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="运输方式：">
                            <span @dblclick="copyText($event)">{{ basicInfo.transportTypeName || '--' }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="备注：">
                            <el-tooltip
                                class="item"
                                effect="dark"
                                :content="basicInfo.remark"
                                placement="top-start"
                            >
                                <span @dblclick="copyText($event)">{{ basicInfo.remark || '--'}}</span>
                            </el-tooltip>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否围栏内发车：">
                            <span @dblclick="copyText($event)">{{ basicInfo.fenceDepartFlagName || '--' }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="实际运作车型名称：">
                            <span @dblclick="copyText($event)">{{ basicInfo.equipmentOperateName || '--' }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div class="second-wrapper">
                <div class="second-header" @click="changeState('isMoreInfoShow')">
                    <strong>更多信息</strong>
                    <i :class="['el-icon', 'mgr-10', isMoreInfoShow ? 'el-icon-arrow-down' :'el-icon-arrow-right']"></i>
                </div>
                <div class="second-content-wrapper" v-show="isMoreInfoShow">

                    <el-card class="second-content">
                        <div slot="header" class="second-content-title">
                            <span>打印信息</span>
                        </div>
                        <el-form label-position="left" label-width="110px">
                            <el-form-item label="司机自助打印：">
                                <span @dblclick="copyText($event)">{{ basicInfo.isDriverSelfPrintName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="打印模板：">
                                <span @dblclick="copyText($event)">{{ basicInfo.driverPrintTemplateName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="打印时间：">
                                <span @dblclick="copyText($event)">{{ basicInfo.driverPrintTime || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="打印人：">
                                <span @dblclick="copyText($event)">{{ basicInfo.driverPrintName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="打印状态：">
                                <span @dblclick="copyText($event)">{{ basicInfo.driverPrintStatusName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="打印次数：">
                                <span @dblclick="copyText($event)">{{ basicInfo.driverPrintCount || '--'}}</span>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card class="second-content">
                        <div slot="header" class="second-content-title">
                            <span >无车平台信息</span>
                        </div>
                        <el-form label-position="left" label-width="110px">
                            <el-form-item label="是否无车平台：">
                                <span @dblclick="copyText($event)">{{ basicInfo.noCarPlatformFlagName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="无车平台类型：">
                                <span @dblclick="copyText($event)">{{ basicInfo.noCarCarrierTypeName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="无车承运商：">
                                <span @dblclick="copyText($event)">{{ basicInfo.noCarCarrierName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="网络调车单号：">
                                <span @dblclick="copyText($event)">{{ basicInfo.netDispatchNo || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="NTP成交价：">
                                <span @dblclick="copyText($event)">{{ formateValue(basicInfo.ntpCost) }}</span>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card class="second-content">
                        <div slot="header" class="second-content-title">
                            <span>设备信息</span>
                        </div>
                        <el-form label-position="left" label-width="120px">
                            <el-form-item label="是否绑定设备号：">
                                <span @dblclick="copyText($event)">{{ basicInfo.bindingDeviceFlagName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="设备类型：">
                                <span @dblclick="copyText($event)">{{ basicInfo.deviceTypeName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="设备号：">
                                <span @dblclick="copyText($event)">{{ basicInfo.deviceNo || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="绑定时间：">
                                <span @dblclick="copyText($event)">{{ basicInfo.deviceNoBoundTime || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="解绑时间：">
                                <span @dblclick="copyText($event)">{{ basicInfo.deviceNoUnboundTime || '--'}}</span>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card class="second-content">
                        <div slot="header" class="second-content-title">
                            <span>装载信息</span>
                        </div>
                        <el-form label-position="left" label-width="130px">
                            <el-form-item label="装载类型：">
                                <span @dblclick="copyText($event)">{{ basicInfo.loadTypeName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="额定装载量(m³)：">
                                <span @dblclick="copyText($event)">{{ formateValue(basicInfo.ratedLoad) }}</span>
                            </el-form-item>
                            <el-form-item label="装载率体积(m³)：">
                                <span @dblclick="copyText($event)">{{ formateValue(basicInfo.loadRateVolume) }}</span>
                            </el-form-item>
                            <el-form-item label="满载率：">
                                <span @dblclick="copyText($event)">{{ formateValue(basicInfo.fullLoadRate) }}</span>
                            </el-form-item>
                            <el-form-item label="装载过低类型：">
                                <span @dblclick="copyText($event)">{{ basicInfo.exceptionTypeName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="装载过低异常备注：">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="basicInfo.exceptionMark"
                                    placement="top-start"
                                >
                                    <span @dblclick="copyText($event)">{{ basicInfo.exceptionMark || '--'}}</span>
                                </el-tooltip>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card class="second-content">
                        <div slot="header" class="second-content-title">
                            <span>审批信息</span>
                        </div>
                        <el-form label-position="left" label-width="155px">
                            <el-form-item label="是否发起审批：">
                                <span @dblclick="copyText($event)">{{ basicInfo.isIflowName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="审批状态：">
                                <span @dblclick="copyText($event)">{{ basicInfo.iflowStatusName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="审批链接：">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="basicInfo.iflowLink"
                                    placement="top-start"
                                >
                                    <el-button
                                        type="text"
                                        @click="openUrl(basicInfo.iflowLink)"
                                    >
                                        <span :class="basicInfo.iflowLink ? 'link-text' : ''">{{ basicInfo.iflowLink || '--'}}</span>
                                    </el-button>
                                </el-tooltip>
                            </el-form-item>
                            <el-form-item label="事业部合同外审批状态：">
                                <span @dblclick="copyText($event)">{{ basicInfo.businessIflowStatusName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="事业部合同外审批链接：">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="basicInfo.businessIflowUrl"
                                    placement="top-start"
                                >
                                    <el-button
                                        type="text"
                                        @click="openUrl(basicInfo.businessIflowUrl)"
                                    >
                                        <span :class="basicInfo.iflowLink ? 'link-text' : ''">{{ basicInfo.businessIflowUrl || '--'}}</span>
                                    </el-button>
                                </el-tooltip>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card class="second-content">
                        <div slot="header" class="second-content-title">
                            <span>运输协议信息</span>
                            <!-- <el-button
                                type="text"
                                v-has="'150101014'"
                                v-if="basicInfo.procurementChannel === '00'"
                                @click="handleViewTransportProtocol"
                            >
                                查看
                            </el-button> -->
                        </div>
                        <el-form label-position="left" label-width="130px">
                            <el-form-item label="运输协议签署状态：">
                                <span @dblclick="copyText($event)">{{ basicInfo.transportProtocolStatusName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="运输协议编号：">
                                <span @dblclick="copyText($event)">{{ basicInfo.transportProtocolCode || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="生成方式：">
                                <span @dblclick="copyText($event)">{{ basicInfo.createWayName || '--'}}</span>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card class="second-content">
                        <div slot="header" class="second-content-title">
                            <span>零担信息</span>
                        </div>
                        <el-form label-position="left" label-width="110px">
                            <el-form-item label="零担下发状态：">
                                <span @dblclick="copyText($event)">{{ basicInfo.lclStatusName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="下发零担平台：">
                                <span @dblclick="copyText($event)">{{ basicInfo.lclPlate || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="是否零担下发：">
                                <span @dblclick="copyText($event)">{{ basicInfo.otpLdFlagName || '--'}}</span>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card class="second-content">
                        <div slot="header" class="second-content-title">
                            <span>在途联系人信息</span>
                        </div>
                        <el-form label-position="left" label-width="110px">
                            <el-form-item label="在途联系类别：">
                                <span @dblclick="copyText($event)">{{ basicInfo.onWayContactCategoryName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="在途联系人：">
                                <span @dblclick="copyText($event)">{{ basicInfo.onWayContactName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="在途联系电话：">
                                <span @dblclick="copyText($event)">{{ basicInfo.onWayContactPhone || '--'}}</span>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card class="second-content">
                        <div slot="header" class="second-content-title">
                            <span>逆向信息</span>
                        </div>
                        <el-form label-position="left" label-width="100px">
                            <el-form-item label="是否正向：">
                                <span @dblclick="copyText($event)">{{ basicInfo.twowayName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="是否退货：">
                                <span @dblclick="copyText($event)">{{ basicInfo.isRejectName || '--'}}</span>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card class="second-content">
                        <div slot="header" class="second-content-title">
                            <span>属性信息</span>
                        </div>
                        <el-form label-position="left" label-width="120px">
                            <el-form-item label="出入库类型：">
                                <span @dblclick="copyText($event)">{{ basicInfo.inOutTypeName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="发运场景：">
                                <span @dblclick="copyText($event)">{{ basicInfo.shippingSceneTypeName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="高端服务发车单：">
                                <span @dblclick="copyText($event)">{{ basicInfo.orderTypeExtName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="内外部渠道：">
                                <span @dblclick="copyText($event)">{{ basicInfo.customerAttribute || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="是否直通宝转运：">
                                <span @dblclick="copyText($event)">{{ basicInfo.ztbTransportFlagName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="是否关联订单：">
                                <span @dblclick="copyText($event)">{{ basicInfo.isAssociatedOrderName || '--'}}</span>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card class="second-content">
                        <div slot="header" class="second-content-title">
                            <span>直控信息</span>
                        </div>
                        <el-form label-position="left" label-width="110px">
                            <el-form-item label="是否直控运力：">
                                <span @dblclick="copyText($event)">{{ basicInfo.directControlCarrierFlagName || '--'}}</span>
                            </el-form-item>
                            <el-form-item label="是否直控线路：">
                                <span @dblclick="copyText($event)">{{ basicInfo.directControlLineFlagName || '--'}}</span>
                            </el-form-item>
                        </el-form>
                    </el-card>
                    <el-card class="second-content full-width">
                        <div slot="header" class="second-content-title">
                            <span>其他信息</span>
                        </div>
                        <el-form label-position="left" label-width="130px">
                            <el-row>
                                <el-col :span="6">
                                    <el-form-item label="合同编号：">
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            :content="basicInfo.contractNo"
                                            placement="top-start"
                                        >
                                            <span @dblclick="copyText($event)">{{ basicInfo.contractNo || '--'}}</span>
                                        </el-tooltip>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="未下发原因分类：">
                                        <span @dblclick="copyText($event)">{{ basicInfo.ztbUnissueReasonName || '--'}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="离园时间：">
                                        <span @dblclick="copyText($event)">{{ basicInfo.leaveDate || '--'}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="预计逾期时间：">
                                        <span @dblclick="copyText($event)">{{ basicInfo.besOverdueDate || '--'}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="发货单号：">
                                        <span @dblclick="copyText($event)">{{ basicInfo.dispatchNoMapping || '--'}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="是否可见：">
                                        <span @dblclick="copyText($event)">{{ basicInfo.carrierVisibleFlagName || '--'}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="排队编码：">
                                        <span @dblclick="copyText($event)">{{ basicInfo.queueCode || '--'}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="异常备注：">
                                        <span @dblclick="copyText($event)">{{ basicInfo.departExceptionRemarksName || '--'}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="快递单号：">
                                        <span @dblclick="copyText($event)">{{ basicInfo.expressNo || '--'}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="异常其他信息：">
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            :content="basicInfo.departExceptionInformation"
                                            placement="top-start"
                                        >
                                            <span @dblclick="copyText($event)">{{ basicInfo.departExceptionInformation || '--'}}</span>
                                        </el-tooltip>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item label="预排车调度类型：">
                                        <span @dblclick="copyText($event)">{{ basicInfo.dispatchTypeName || '--'}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>
                </div>
            </div>
        </div>
        <dispatch-transport-protocol
            v-if="showTransportProtocol"
            :componentsData="transportProtocolData"
            @components-close="componentsClose"
        ></dispatch-transport-protocol>
   </div>
</template>

<script>
import { copyToClip } from '../util.js';
import DispatchTransportProtocol from '../../components/dispatchTransportProtocol/Index';
export default {
    name: 'BasicInformation',
    components: { DispatchTransportProtocol },
    props: {
        dispatchNo: {
            type: String,
            default () {
                return '';
            }
        },
        basicInfo: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    data () {
        return {
            isBasicInfoShow: true,
            isMoreInfoShow: false,
            showTransportProtocol: false,
            transportProtocolData: {}
        };
    },
    computed: {
        formateValue () {
            return function (val) {
                return (val !== null && val !== undefined && val !== '') ? val : '--';
            };
        },
        // 计费车型新增图标：光标点击后，悬浮提示内容，内容做成参数配置，上线初始化：“请按真实运作车型排车，如果计费车型错误，发车之后OMS改单修改车型，不允许SRM乱维护车牌号对应的运作车型”
        equipmentRequirement() {
            const dictObj = this.dictData.BILLING_VEHICLE_TYPE_REQUIREMENT;
            return dictObj ? dictObj.value : '';
        }
    },
    methods: {
        changeState (state) {
            this[state] = !this[state];
        },
        /**
         * @description 双击复制
         * @param {*} e
         */
        copyText (e) {
            const value = (e.target.innerHTML).trim();
            value !== '--' && copyToClip(value);
        },
        linkToMapMonitor () {
            this.$router.push({
                path: '/otp/distribute/dispatch-inRoad-monitor',
                query: {
                    dispatchNo: this.dispatchNo
                }
            });
        },
        openUrl (url) {
            if (!url || url === '--') return;
            window.open(url);
        },
        handleViewTransportProtocol () {
            this.transportProtocolData = {
                dispatchNo: this.basicInfo.dispatchNo,
                vehicleCard: this.basicInfo.vehicleCard,
                driver: this.basicInfo.driver,
                driverContactWay: this.basicInfo.driverContactWay,
                dispatchStatus: this.basicInfo.dispatchStatus,
                id: this.basicInfo.id
            };
            this.showTransportProtocol = true;
        },
        componentsClose () {
            this.showTransportProtocol = false;
        }
    }
};
</script>

<style lang="less" scoped>
@import '../dispatchInfoDetail.less';
.basic-info {
    background-color: #fff;
    margin-bottom: 14px;
    .basic-wrapper {
        padding: 10px 0 10px 20px;
        // padding-left: 20px;
        border-bottom: 2px solid #ebeef5;
    }
    .second-wrapper {
        padding: 6px 0px 10px 20px;
        .second-header {
            display: flex;
            justify-content: space-between;
            font-size: 15px;
        }
        .second-content-wrapper {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 10px;
            padding: 10px 20px 0px 0px
        }
        /deep/ .second-content {
            .el-card__header {
                padding: 8px 12px !important;
            }
            .el-card__body {
                padding: 8px 12px !important;
            }
            .second-content-title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                .el-button--text {
                    padding: 0px;
                }
            }
            /deep/ .el-form-item__label {
                font-size: 12px;
                color: #999;
            }
            .el-form-item {
                .link-text {
                    color: #00BCBF;
                    white-space: nowrap; /*文字不换行，为了让文字溢出*/
                    overflow: hidden; /*隐藏滚动条*/
                    text-overflow: ellipsis; /*溢出部分显示为“...”*/
                }
            }
        }
        .full-width {
            grid-column: span 4;
        }
    }
}
</style>
